import React, { useCallback, useContext, useEffect, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { Box, Button, Checkbox, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import helper from '../../../helper';
import brokerApi from '../../../api/brokerApi';
import reservationApi from '../../../api/reservationApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import planApi from '../../../api/planApi';
import hotelApi from '../../../api/hotelApi';
import QuotaPeriodApi from '../../../api/quotaPeriodApi';
import cityApi from '../../../api/cityApi';

import ChunkedPlanRooms from '../../../Components/ChunkedPlanRooms';
import stationApi from '../../../api/stationApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import hotelStructureApi from '../../../api/hotelStructureApi';
import brokerGroupApi from '../../../api/brokerGroupApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import enumMapper from '../../../enumMapper';
import InitialPlanFooter from '../../../Components/InitialPlanFooter';

const EditInitialPlan = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [result, setResult] = useState(null);

  const [QuotaPeriods, setQuotaPeriods] = useState([]);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [Plans, SetPlans] = useState([]);
  const [Brokers, SetBrokers] = useState([]);
  const [DispatchOfTheDayDropDown, SetDispatchOfTheDayDropDown] = useState([]);
  const [FlightStations, SetFlightStations] = useState([])
  const [Airlines, SetAirlines] = useState([])
  const [PlanInfoStructure, SetPlanInfoStructure] = useState(null)
  const [BrokerInfo, setBrokerInfo] = useState(null);
  const [Companies, setCompanies] = useState([]);
  const [HotelStructure, SetHotelStructure] = useState({});
  const [HotelPlans, SetHotelPlans] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const [tripInfoForPLan, setTripInfoForPLan] = useState(null)
  const [brokerGroups, setBrokerGroups] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const schema = yup.object().shape({
    planID: yup.string().required("کد پلان ر انتخاب نمایید"),
    capacity: yup.number().positive("ظرفیت بزرگتر از صفر").integer().typeError("فرمت ظرفیت عددی").required("ظرفیت را وارد نمایید"),
    brokerGroupId: yup.string().required("گروه را انتخاب نمایید"),
    CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    hotelId: yup.string().required("هتل را انتخاب نمایید"),
    hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
    brokerId: yup.string().required("کارگزار را انتخاب نمایید"),
  });
  const { register, handleSubmit, formState: { errors }, control, resetField, watch } = useForm({
    defaultValues: async () => {
      return reservationApi.GetByKey(id)
        .then(res => {
          setResult(res.data.data);
          SetPlanInfoStructure(res.data.data.planInfo)

          fetchHotelsByCityConsistency(res.data.data.reserveInfo.cityConsistency);
          fetchHotelStrutureDropDown(res.data.data.reserveInfo.hotelId);
          GetHotelplanReserved(res.data.data.planInfo.hotelStructureId, id);
          // GetBrokerGroupInfoByGroupId(res.data.data.reserveInfo.brokerGroupId)
          setTripInfoForPLan({
            persian_FlightDate: res.data.data.reserveInfo.flightDate,
            originFlightStation: res.data.data.reserveInfo.flightOriginName,
            airLineName: res.data.data.reserveInfo.airLineName
          })
          fetchBrokerGroupByBrokerId(res.data.data.reserveInfo.brokerId)
          return {
            CityConsistency: res.data.data.reserveInfo.cityConsistency.toString(),
            hotelId: res.data.data.reserveInfo.hotelId,

            airLineId: res.data.data.reserveInfo.airLineId,
            planID: res.data.data.reserveInfo.planID,
            flightDate: res.data.data.reserveInfo.flightDate,
            // reservationStartDate:res.data.data.reservationStartDate,
            // reservationEndtDate:res.data.data.reservationEndtDate,
            groupNumber: res.data.data.reserveInfo.groupNumber,
            isActive: res.data.data.reserveInfo.isActive,
            firstDescription: res.data.data.reserveInfo.firstDescription,
            secondDescription: res.data.data.reserveInfo.secondDescription,
            thirdDescription: res.data.data.reserveInfo.thirdDescription,
            dispatchOfTheDay: res.data.data.reserveInfo.dispatchOfTheDay?.toString(),
            capacity: res.data.data.reserveInfo.capacity,
            brokerId: res.data.data.reserveInfo.brokerId,
            flightStationOrigin: res.data.data.reserveInfo.flightStationOrigin,
            //flightStationDestination: res.data.data.reserveInfo.flightStationDestination,
            quotaPeriodId: res.data.data.reserveInfo.quotaPeriodId,
            companyId: res.data.data.reserveInfo.companyId,
            hotelStructureId: res.data.data.planInfo.hotelStructureId,
            brokerGroupId: res.data.data.reserveInfo.brokerGroupId
          }
        })
        .catch(err => console.log(err));
    },
    resolver: yupResolver(schema),
  });

  const brokerId = watch('brokerId');
  const planID = watch('planID');

  const onSubmit = (data) => {
    setSubmitLoading(true);
    let flightDateGregorian = null;
    if (data.flightDate) {
      let flightDate = new DateObject({
        date: data.flightDate,
        calendar: persian,
        locale: persian_fa
      });
      flightDateGregorian = flightDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD");
    }
    const newData = {
      "id": id,
      "planID": data.planID,
      "isActive": data.isActive,
      "firstDescription": data.firstDescription,
      "secondDescription": data.secondDescription,
      "thirdDescription": data.thirdDescription,
      "dispatchOfTheDay": parseInt(data.dispatchOfTheDay),
      "brokerGroupId": data.brokerGroupId,
      "capacity": data.capacity
    }
    reservationApi.Update(newData).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        navigate("/dashboard/InitialPlan/List");
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {

    GetCityDropDown();
    GetBrokerDropDown();
    GetFlightStationDropDown();
    GetAirlineDropDown();
    GetDispatchOfTheDayDropDown();
  }, []);

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const GetDispatchOfTheDayDropDown = () => {
    reservationApi.GetDispatchOfTheDayDropDown()
      .then(res => {
        const arr = helper.DictionayToList(res.data.data)
        SetDispatchOfTheDayDropDown(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch(err => console.log(err));
  }
  const handleDispatchOfTheDayChanged = (id) => { }

  const GetFlightStationDropDown = () => {
    stationApi.GetAll()
      .then((res) => {
        SetFlightStations(res.data.data.map((r) => {
          return {
            id: r.id,
            label: r.name
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const GetAirlineDropDown = () => {
    staticVariablesApi.GetAirLineTypeDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        SetAirlines(arr.map((r) => {
          return {
            id: r.value,
            label: r.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const GetBrokerDropDown = () => {
    brokerApi
      .BrokerDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        SetBrokers(arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const handleBrokerChanged = (id) => {
    setBrokerInfo(null)
    if (id) {
      GetBorkerByKey(id);
      fetchBrokerGroupByBrokerId(id);

    }
  };
  const handleFlightStationOriginChanged = (id) => { }
  const handleAirlineChanged = (id) => { }


  const handleCityChanged = (id) => { };
  const handleHotelChanged = (id) => { };

  const fetchHotelsByCityConsistency = (cityConsistency) => {
    hotelApi.HotelDropDown(cityConsistency)
      .then(res => {
        const arr = helper.DictionayToList(res.data.data)
        setHotels(
          arr.map((o) => {
            return {
              id: o.key,
              label: o.value
            };
          })
        );
      })
      .catch(err => console.log(err))
  }

  const fetchHotelStrutureDropDown = (hotelId) => {
    hotelStructureApi.HotelStrutureDropDown(hotelId).then(res => {
      const arr = helper.DictionayToList(res.data.data)
      setHotelStructureIds(
        arr.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    })
      .catch(err => console.log(err));
  };

  const GetHotelplanReserved = (hotelId, reserveId) => {
    planApi.GetHotelplanReserved(hotelId, reserveId).then(res => {
      const arr = helper.DictionayToList(res.data.data)
      SetPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => {

    })

  }




  const handlePlanChanged = useCallback(async (id) => {
    // resetField("");
    SetPlanInfoStructure(null);
    if (id) {
      const planInfo = await fetchPlanInfoStructureByPlanId(id);


      SetPlanInfoStructure(planInfo)
    }
  }, []);
  const fetchPlanInfoStructureByPlanId = async (planID) => {
    try {
      let res = await planApi.GetPlanInfoStructureByPlanId(planID)
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };

  const GetBorkerByKey = (id) => {
    return brokerApi.GetByKey(id).then(res => {
      setBrokerInfo(res.data.data);
    });
  }
  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
      GetPlanHotelDropDown(id);
    }
  };

  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const GetPlanHotelDropDown = (structureId) => {
    hotelStructureApi.PlanIdHotelStructureDropDown(structureId).then(res => {
      const arr = helper.DictionayToList(res.data.data);
      SetHotelPlans(arr.map((item) => {
        return {
          id: item.key,
          label: item.value
        };
      }));
    }).catch(err => console.log(err));
  };

  const handleBrokerGroupChanged = async (id) => {
    if (id) {
      GetBrokerGroupInfoByGroupId(id)
    }


  }



  const fetchBrokerGroupByBrokerId = async (brokerId) => {
    brokerGroupApi.BrokerGroupDropDown(brokerId).then(res => {
      const arr = helper.DictionayToList(res.data.data)
      setBrokerGroups(
        arr.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }).catch(err => console.log(err));




  };

  const GetBrokerGroupInfoByGroupId = (brokerGroupId) => {
    reservationApi.GetBrokerGroupInfoByGroupId(brokerGroupId).then(res => {
      setTripInfoForPLan({
        persian_FlightDate: res?.data.data.persian_FlightDate,
        originFlightStation: res?.data.data.originFlightStation,
        airLineName: res?.data.data.airLineName
      })
    }).catch(err => console.log(err));
  };

  return (
    <Container component="main" maxWidth={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            ویرایش پلان اقامتی کارگزار
          </Typography>
          <Grid container spacing={1}>

            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={true}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={true}
                error={!!errors?.hotelId}
                helperText={errors?.hotelId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={hotelStructureIds ?? []}
                name="hotelStructureId"
                placeholder="ساختار"
                onChange={handleHotelStructureIdChanged}
                style={{
                  border: "none",
                  padding: 0,
                }}
                error={!!errors?.hotelStructureId}
                helperText={errors?.hotelStructureId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={Plans ?? []}
                name="planID"
                placeholder="پلان"
                onChange={handlePlanChanged}
                error={!!errors?.planID}
                helperText={errors?.planID?.message}
              />

            </Grid>

            <Grid item xs={12} sm={3}>
              <RHFAutocomplete
                control={control}
                options={Brokers ?? []}
                name="brokerId"
                placeholder="کارگزار"
                onChange={handleBrokerChanged}
                error={!!errors?.brokerId}
                helperText={errors?.brokerId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <RHFAutocomplete
                control={control}
                options={brokerGroups ?? []}
                name="brokerGroupId"
                placeholder="گروه"
                onChange={handleBrokerGroupChanged}
                error={!!errors?.brokerGroupId}
                helperText={errors?.brokerGroupId?.message}
              />

            </Grid>
            <Grid item xs={12} sm={10}>
              <FormControlLabel
                control={
                  <Controller
                    name="isActive"
                    control={control}
                    defaultValue={false}
                    render={({ field: { value, ref, ...field } }) => (
                      <Checkbox
                        {...field}
                        inputRef={ref}
                        checked={!!value}
                        color="primary"
                        size={"medium"}
                        disableRipple
                      />
                    )}
                  />
                }
                label="فعال"
                labelPlacement="end"
              />
            </Grid>
            <Grid container item xs={12} sm={2} justifyContent={'flex-end'} mb={2}>
              <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />ویرایش</Button>
            </Grid>
          </Grid>
          <div style={{ overflowX: 'auto' }} dir='rtl'>
            <table width={'100%'} cellSpacing={0} className='initialplantable'>
              <tbody>
                <tr style={{ background: "#f2f2f2" }}>
                  <th colSpan="3">نام کارگزار</th>
                  <th colSpan="2">شماره کارگزار</th>
                  <th colSpan="1">شماره گروه</th>
                  <th colSpan="1">شرکت مجری عربی </th>
                  <th colSpan="1">تاریخ پرواز</th>
                  <th colSpan="1">تاریخ نگارش</th>
                </tr>
                <tr style={{ background: "#f2f2f2" }}>
                  <td colSpan="3">{brokerId === result?.reserveInfo?.brokerId ?
                    result?.reserveInfo?.brokerName : BrokerInfo?.name
                  }</td>
                  <td colSpan="2">{brokerId === result?.reserveInfo?.brokerId ?
                    result?.reserveInfo?.brokerCode : BrokerInfo?.code
                  }</td>
                  <td colSpan="1"> <TextField id="outlined-basic" variant="outlined" {...register("groupNumber")} label="شماره گروه" style={{ width: 120 }} margin="normal" InputLabelProps={{ shrink: true }} error={!!errors?.groupNumber}
                    helperText={errors?.groupNumber?.message} />
                  </td>
                  <td colSpan="1">
                    {result?.reserveInfo?.companyName}
                  </td>
                  <td colSpan="1">
                    {
                      tripInfoForPLan?.persian_FlightDate
                    }
                  </td>
                  <td colSpan="1">{result?.reserveInfo?.createDate}</td>
                </tr>
                <tr style={{ background: "#f8cbae" }}>
                  <th>نام هتل</th>
                  <th>شهر</th>
                  <th>کد پلان</th>
                  <th>گروه قیمتی</th>
                  <th>ظرفیت</th>
                  <th>اعزام روز</th>
                  <th>تعداد کل اتاق</th>
                  <th>ایستگاه پروازی</th>
                  <th>هواپیمایی</th>
                </tr>
                <tr style={{ background: PlanInfoStructure?.colorCode }}>
                  <td> {result?.reserveInfo?.hotelName}</td>
                  <td>{result?.reserveInfo?.cityName}</td>
                  <td>  {result?.planInfo?.planCode}</td>
                  <td> {result?.reserveInfo?.priceGroupName}</td>
                  <td><TextField type="number" id="outlined-basic" variant="outlined" {...register("capacity")} label="ظرفیت" style={{ width: 80 }} margin="normal" InputLabelProps={{ shrink: true }} error={!!errors?.capacity}
                    helperText={errors?.capacity?.message} />
                  </td>
                  <td>
                    <RHFAutocomplete
                      control={control}
                      options={DispatchOfTheDayDropDown ?? []}
                      name="dispatchOfTheDay"
                      placeholder="اعزام روز"
                      onChange={handleDispatchOfTheDayChanged}
                      style={{
                        width: 130,
                        border: "none",
                        padding: 0
                      }}
                    /></td>
                  <td>
                    {planID === result?.reserveInfo?.planID ?
                      result?.reserveInfo?.roomCount : PlanInfoStructure?.roomCount
                    }
                  </td>
                  <td>
                    {
                      tripInfoForPLan?.originFlightStation
                    }


                  </td>
                  <td>
                    {tripInfoForPLan?.airLineName}
                  </td>
                </tr>
                <tr>
                  <th>آدرس</th>
                  <td colSpan={8}>{result?.reserveInfo?.address}
                    <br />
                    {result?.reserveInfo?.arabianAddress}
                  </td>
                </tr>
                <tr>
                  <th>تلفن</th>
                  <td colSpan={1}>
                    {result?.reserveInfo?.phoneNumber}
                  </td>
                  <th colSpan={7}>مدیر محترم به کروکی مهندسی پیوست هنگام توزیع اتاق ها توجه گردد.</th>
                </tr>
                <tr>
                  <td colSpan={9}>
                    <table cellSpacing={0} className='innertable'>
                      <tbody>
                        {
                          PlanInfoStructure?.floors?.map((item) => (
                            <ChunkedPlanRooms item={item} colorCode={PlanInfoStructure?.colorCode} />
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th rowSpan="3">توضیحات</th>
                  <td colSpan={8}><TextField id="outlined-basic" variant="outlined" {...register("firstDescription")} fullWidth label="توضیحات 1" InputLabelProps={{ shrink: true }} margin="normal" />
                  </td>
                </tr>
                <tr>
                  <td colSpan={8}> <TextField id="outlined-basic" variant="outlined" {...register("secondDescription")} fullWidth label="توضیحات 2" InputLabelProps={{ shrink: true }} margin="normal" />
                  </td>
                </tr>
                <tr>
                  <td colSpan={8}>
                    <TextField id="outlined-basic" variant="outlined" {...register("thirdDescription")} fullWidth label="توضیحات 3" InputLabelProps={{ shrink: true }} margin="normal" />
                  </td>
                </tr>
                <tr>
                  <td colSpan={11}>
                    {/* <InitialPlanFooter PlanInfoStructure={PlanInfoStructure}/> */}
                    <InitialPlanFooter planInfo={PlanInfoStructure} countTreeBed={PlanInfoStructure?.countTreeBed} countTwoBed={PlanInfoStructure?.countTwoBed} countFourBed={PlanInfoStructure?.countFourBed} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </RtlProvider>
      </form>
    </Container>
  )
}
export default EditInitialPlan;